define('SuiteDynamics.PickedForYouHomepage.Slider.View',
	[
		'jQuery',
		'ItemRelations.Related.View',
		'ItemRelations.RelatedItem.View',
		'SuiteDynamics.PickedForYouHomepage.Slider.Collection',
		'Backbone.CollectionView',
		'suitedynamics_pickedforyou_slider.tpl',
		'item_relations_row.tpl',
		'item_relations_cell.tpl'
	],
	function (
		jQuery,
		ItemRelationsRelatedView,
		ItemRelationsRelatedItemView,
		SliderCollection,
		BackboneCollectionView,
		suitedynamics_pickedforyou_slider_tpl,
		item_relations_row_tpl,
		item_relations_cell_tpl
	)
{
	'use strict';

	return ItemRelationsRelatedView.extend({
		events: {
			'click .scroll-left': 'scrollLeft',
			'click .scroll-right': 'scrollRight'
		},

		initialize: function(options) {
			var environment = options.container.getComponent('Environment');
			var itemIds = environment.getConfig('pickedForYou.items') || [];

			if (!itemIds.length) return;

			var collection = new SliderCollection({
				itemIds: itemIds
			});

			BackboneCollectionView.prototype.initialize.call(this, {
				collection: collection,
				viewsPerRow: Infinity,
				cellTemplate: item_relations_cell_tpl,
				rowTemplate: item_relations_row_tpl,
				childView: ItemRelationsRelatedItemView,
				template: suitedynamics_pickedforyou_slider_tpl
			});

			this.loadRelatedItem();

			var layout = options.container.getComponent('Layout');
			var self = this;

			layout.application.getLayout().once('afterAppendView', function() {
				self.bindScrollEvent();
				self.handleScroll();
			});
		},

		render: function() {
			ItemRelationsRelatedView.prototype.render.apply(this, arguments);

			var environment = this.options.container.getComponent('Environment');
			var itemIds = environment.getConfig('pickedForYou.items') || [];

			if (!itemIds.length) return;

			this.bindScrollEvent();
			this.handleScroll();
		},

		loadRelatedItem: function loadRelatedItem() {
			var self = this;

			self.collection.fetchItems().then(function() {
				self.render();
			});
		},

		bindScrollEvent: function() {
			var container = this.$('.picked-for-you-container .item-relations-row');
			if (container.length) {
				container[0].addEventListener('scroll', this.handleScroll.bind(this));
			}
		},

		scrollLeft: function() {
			var container = this.$('.picked-for-you-container .item-relations-row')[0];
			var itemWidth = this.getItemWidth();
			container.scrollLeft -= itemWidth;
			this.handleScroll();
		},

		scrollRight: function() {
			var container = this.$('.picked-for-you-container .item-relations-row')[0];
			var itemWidth = this.getItemWidth();
			container.scrollLeft += itemWidth;
			this.handleScroll();
		},

		handleScroll: function() {
			var container = this.$('.picked-for-you-container .item-relations-row')[0];
			var scrollLeftButton = this.$('.picked-for-you-container .scroll-left');
			var scrollRightButton = this.$('.picked-for-you-container .scroll-right');

			var scrollLeft = container.scrollLeft;
			var offsetWidth = container.offsetWidth;
			var scrollWidth = container.scrollWidth;

			var isAtStart = scrollLeft <= 1;
			var isAtEnd = scrollLeft + offsetWidth >= scrollWidth - 1;
			isAtEnd = isAtEnd || Math.abs((scrollLeft + offsetWidth) - scrollWidth) < 1;

			if (isAtStart) {
				scrollLeftButton.addClass('hidden');
			} else {
				scrollLeftButton.removeClass('hidden');
			}

			if (isAtEnd) {
				scrollRightButton.addClass('hidden');
			} else {
				scrollRightButton.removeClass('hidden');
			}
		},

		getItemWidth: function() {
			var firstItem = jQuery('.picked-for-you-container .item-relations-cell:first');
			return firstItem.length ? firstItem.outerWidth(true) + 30 : 0;
		}
	});
});
